"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["children", "className", "inline"],
    _excluded2 = ["className"],
    _excluded3 = ["children", "className", "displayType", "inline", "outside", "position", "shape", "size"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Overlay = function Overlay(_ref) {
  var children = _ref.children,
      className = _ref.className,
      inline = _ref.inline,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: (0, _classnames.default)(className, 'sticker-overlay', {
      'inline-item': inline
    })
  }, otherProps), children);
};

var Image = function Image(_ref2) {
  var className = _ref2.className,
      otherProps = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_react.default.createElement("img", _extends({
    className: (0, _classnames.default)(className, 'sticker-img')
  }, otherProps));
};

function ClaySticker(_ref3) {
  var _classNames;

  var children = _ref3.children,
      className = _ref3.className,
      displayType = _ref3.displayType,
      inline = _ref3.inline,
      _ref3$outside = _ref3.outside,
      outside = _ref3$outside === void 0 ? false : _ref3$outside,
      position = _ref3.position,
      shape = _ref3.shape,
      size = _ref3.size,
      otherProps = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/_react.default.createElement("span", _extends({}, otherProps, {
    className: (0, _classnames.default)('sticker', className, (_classNames = {}, _defineProperty(_classNames, "sticker-".concat(shape), shape), _defineProperty(_classNames, "sticker-".concat(displayType), displayType), _defineProperty(_classNames, "sticker-".concat(position), position), _defineProperty(_classNames, "sticker-outside", position && outside), _defineProperty(_classNames, "sticker-".concat(size), size), _classNames))
  }), /*#__PURE__*/_react.default.createElement(Overlay, {
    inline: inline
  }, children));
}

ClaySticker.Image = Image;
ClaySticker.Overlay = Overlay;
var _default = ClaySticker;
exports.default = _default;